@if (isModal) {
<div class="modal-header bg-modal-header">
  <h4 class="mb-0 modal-title text-white">{{pageInfo?.title | titlecase}}</h4>
  <div class="close-btn text-white" (click)="close()">X</div>
</div>
}
@if (!isModal) {
<div class="block-header">
  <!-- <div class="row clearfix">
    <div class="col-md-6 col-sm-12">
      <h3>{{pageInfo?.title}}</h3>
    </div>
    <div class="col-md-6 col-sm-12 text-right hidden-xs bd-col">
      @if (pageInfo?.buttonShowBtn;) {
      <button (click)="btnClick()" class="btn btn-sm {{pageInfo?.button?.class || 'btn-primary'}}"
        title="{{pageInfo?.button?.title}}"><i [class.icon-list]="!pageInfo?.button?.icon"
          class="{{pageInfo?.button?.icon}} mr-1"></i> {{pageInfo?.button?.title}}</button>

      }
      <ng-template #btnBack>
        <a href="javascript:void(0)" (click)="close()" class="btn btn-sm btn-primary" title="Back"><i
            class="pi pi-arrow-left"></i> Back</a>
      </ng-template>
      @if (pageInfo?.info_text) {
      <span class="text-muted text-right lead" style="padding-left: 73vw;">{{pageInfo?.info_text}}</span>
      }
    </div> -->
  <div class="clearfix row">
    <div class="col-12">
      <div class="page-title-box">
        <div class="page-title-right">
          @if (pageInfo?.buttonShowBtn;) {
          <div>
            <!-- <button (click)="btnClick()" class="btn btn-sm me-2 {{pageInfo?.button?.class || 'btn-primary'}}"
              title="{{pageInfo?.button?.title}}"><i [class.icon-list]="!pageInfo?.button?.icon"
                class="{{pageInfo?.button?.icon}} mr-1"></i> {{pageInfo?.button?.title}}</button> -->
            <p-button class="my-button" (click)="btnClick()" [severity]="pageInfo?.button?.severity" size="small"
              [class]=" pageInfo?.button?.class" [label]="pageInfo?.button?.title"
              [icon]="pageInfo?.button?.icon || 'pi pi-list'"></p-button>
          </div>
          <!-- <a href="javascript:void(0)" *ngIf="pageInfo?.buttonShowBtn; else btnBack"
                  [routerLink]="[pageInfo?.button?.url]" [queryParams]="pageInfo?.button?.queryParams || ''"
                ></a> -->
          }
          <ng-template #btnBack>
            <a href="javascript:void(0)" (click)="close()" class="btn btn-sm btn-primary" title="Back"><i
                class="pi pi-arrow-left"></i> Back</a>
          </ng-template>
          @if (pageInfo?.info_text) {
          <span class="text-muted lead float-end mt-1">{{pageInfo?.info_text}}</span>
          }
        </div>

        <h4 class="page-title">{{pageInfo?.title}}</h4>
      </div>
    </div>
  </div>
</div>
}